import type { Ref } from 'vue';

/**
 * Shared state holding the server's draft-mode verdict.
 *
 * Written once during SSR by layers/base/plugins/sanityDraftMode.server.ts from the httpOnly
 * `sanity-preview-id` cookie. Deliberately separate from @nuxtjs/sanity's
 * `visualEditingState.enabled`, which also gates whether the overlay mounts and is therefore
 * cleared outside Presentation — see layers/base/plugins/sanityPresentationGate.client.ts.
 */
export function useSanityDraftModeState(): Ref<boolean> {
  return useState<boolean>('sanity-draft-mode', () => false);
}

/**
 * Whether the current session is in Sanity draft mode.
 *
 * True for an editor with an active preview session, whether or not they are inside the
 * Presentation tool — which is the point: it drives the bar offering the way out.
 */
export function useDraftMode() {
  const draftMode = useSanityDraftModeState();

  return reactive({
    isDraftMode: computed(() => draftMode.value),
  });
}
